import React from 'react';
import { ArrowRight, Globe2, LayoutDashboard, Rocket, Smartphone, Workflow } from 'lucide-react';
import { Link } from 'react-router-dom';
import { DMPLogo } from '../components/brand/DMPLogo';
import { BdFlag } from '../components/brand/BdFlag';
import { demoFlows } from '../data/demoFlows';
import { toBn } from '../utils/bangla';
const apps = [{
  to: '/admin/login',
  icon: LayoutDashboard,
  title: 'ডিএমপি ওয়েব অ্যাডমিনিস্ট্রেশন পোর্টাল',
  desc: 'নোটিশ আপলোড, AI/OCR, যাচাই, অনুমোদন, QR নোটিশ তৈরি, প্রিন্ট-প্রেরণ ও মনিটরিং',
  meta: 'ডেস্কটপ • ১৮টি স্ক্রিন',
  color: '#003B71'
}, {
  to: '/officer',
  icon: Smartphone,
  title: 'ডিএমপি অফিসার মোবাইল অ্যাপ',
  desc: 'মাঠ পর্যায়ে নোটিশের ছবি তোলা, OCR ফলাফল সংশোধন ও যাচাইয়ের জন্য প্রেরণ',
  meta: 'মোবাইল • ১০টি স্ক্রিন',
  color: '#006A4E'
}, {
  to: '/citizen',
  icon: Globe2,
  title: 'নাগরিক নোটিশ যাচাই পোর্টাল',
  desc: 'লগইন ছাড়াই QR স্ক্যান বা মামলা নম্বর দিয়ে নোটিশের সত্যতা যাচাই ও প্রতারণা রিপোর্ট',
  meta: 'রেসপন্সিভ • ১৩টি স্ক্রিন',
  color: '#1769AA'
}];
export function PrototypeHub() {
  return <div className="min-h-screen w-full bg-[#F4F7FB]" data-id="element-2250" data-mp="3nl8mx0ti16hp">
      <header className="bg-[#003B71] text-white" data-id="element-2251" data-mp="567s9wklzwch">
        <div className="mx-auto flex max-w-7xl items-center gap-4 px-6 py-5" data-id="element-2252" data-mp="56zdqekhsdp1">
          <DMPLogo size={60} data-id="element-2253" data-mp="e687oh791bw" />
          <div className="flex-1" data-id="element-2254" data-mp="cv4tpro1vlb">
            <div className="text-sm text-white/75" data-id="element-2255" data-mp="f3cetxid9ttt">গণপ্রজাতন্ত্রী বাংলাদেশ সরকার • বাংলাদেশ পুলিশ</div>
            <div className="text-xl font-bold md:text-2xl" data-id="element-2256" data-mp="a5aoqsmiwu8u">ঢাকা মেট্রোপলিটন পুলিশ (ডিএমপি)</div>
          </div>
          <BdFlag width={44} data-id="element-2257" data-mp="o3hc3etujbu9" />
        </div>
        <div className="h-1 bg-[#006A4E]" data-id="element-2258" data-mp="o2fyb2lg4b8u" />
      </header>

      <main className="mx-auto max-w-7xl px-6 py-10" data-id="element-2259" data-mp="j6ilh69e5n0t">
        <div className="mb-2 inline-flex rounded-full bg-[#FDF3E2] px-3 py-1 text-xs font-medium text-[#A86A06]" data-id="element-2260" data-mp="2pvx4s2xub620">প্রোটোটাইপ প্রদর্শনী • সকল তথ্য নমুনা</div>
        <h1 className="text-3xl font-bold leading-snug text-[#003B71] md:text-4xl" data-id="element-2261" data-mp="2ky3xf6ksw605">এআই ট্রাফিক প্রসিকিউশন নোটিশ যাচাই ও ভেরিফিকেশন প্ল্যাটফর্ম</h1>
        <p className="mt-2 text-base text-slate-600" data-id="element-2262" data-mp="tsr3d0h3u41p">DMP AI Traffic Prosecution Notice Validation &amp; Verification Platform — বিদ্যমান AI প্রসিকিউশন ব্যবস্থার পরিপূরক একটি নোটিশ ডিজিটাইজেশন ও যাচাই প্ল্যাটফর্ম।</p>

        <div className="mt-8 grid gap-5 md:grid-cols-3" data-id="element-2263" data-mp="12tyo0fqp76db">
          {apps.map(a => {
          const Icon = a.icon;
          return <Link key={a.to} to={a.to} className="group flex flex-col rounded-xl border border-border bg-white p-6 transition-shadow hover:shadow-lg" data-id="element-2264" data-mp="17s9wam1ch8tf">
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg text-white" style={{
              backgroundColor: a.color
            }} data-id="element-2265" data-mp="1hhthvzgfzgrz">
                  <Icon className="h-6 w-6" data-id="element-2266" data-mp="1mgwjf9x7r4v7" />
                </div>
                <h2 className="text-lg font-bold text-[#003B71]" data-id="element-2267" data-mp="1qjt0gw73usx1">{a.title}</h2>
                <p className="mt-1.5 flex-1 text-sm text-slate-600" data-id="element-2268" data-mp="1vhuqk12y7si0">{a.desc}</p>
                <div className="mt-5 flex items-center justify-between border-t border-border pt-4 text-sm" data-id="element-2269" data-mp="1vfrqspbzul03">
                  <span className="text-slate-500" data-id="element-2270" data-mp="3b127si3rfsfy">{a.meta}</span>
                  <span className="flex items-center gap-1 font-semibold text-[#1769AA] group-hover:gap-2" data-id="element-2271" data-mp="3azr2gduo2cmq">
                    প্রবেশ করুন <ArrowRight className="h-4 w-4" data-id="element-2272" data-mp="371bh0ee8hcbf" />
                  </span>
                </div>
              </Link>;
        })}
        </div>

        <div className="mt-5 grid gap-5 md:grid-cols-2" data-id="element-2273" data-mp="2jz0lz4wob2a">
          <Link to="/process" className="flex items-center gap-4 rounded-xl border border-border bg-white p-5 hover:shadow-md" data-id="element-2274" data-mp="3upb9bir71as4">
            <Workflow className="h-9 w-9 text-[#006A4E]" data-id="element-2275" data-mp="3pxb2r7gmbjmk" />
            <div className="flex-1" data-id="element-2276" data-mp="3kz9i4i3jnc8z">
              <div className="font-bold text-[#003B71]" data-id="element-2277" data-mp="3ky6v4l9cdtyc">প্রস্তাবিত প্রক্রিয়া চিত্র</div>
              <div className="text-sm text-slate-600" data-id="element-2278" data-mp="m9hpov1kfj6u">AI ক্যামেরা থেকে নাগরিক যাচাই পর্যন্ত ১৬ ধাপের এক্সিকিউটিভ উপস্থাপনা</div>
            </div>
            <ArrowRight className="h-5 w-5 text-slate-400" data-id="element-2279" data-mp="hgg8uhhst9km" />
          </Link>
          <Link to="/roadmap" className="flex items-center gap-4 rounded-xl border border-border bg-white p-5 hover:shadow-md" data-id="element-2280" data-mp="128nhqykis0j">
            <Rocket className="h-9 w-9 text-[#1769AA]" data-id="element-2281" data-mp="600kgze2l4bl" />
            <div className="flex-1" data-id="element-2282" data-mp="3o8rknnp4qasu">
              <div className="font-bold text-[#003B71]" data-id="element-2283" data-mp="3o9sz825ctffb">ভবিষ্যৎ সম্প্রসারণ</div>
              <div className="text-sm text-slate-600" data-id="element-2284" data-mp="3t7ckhm0gysgr">BRTA, e-Challan ও অনলাইন জরিমানা পরিশোধ — পর্যায়ভিত্তিক রোডম্যাপ</div>
            </div>
            <ArrowRight className="h-5 w-5 text-slate-400" data-id="element-2285" data-mp="osl3zq7vpx2q" />
          </Link>
        </div>

        <section className="mt-10" data-id="element-2286" data-mp="b17pwrsqprf3">
          <h2 className="mb-4 text-xl font-bold text-[#003B71]" data-id="element-2287" data-mp="b1ziruuydb1o">প্রদর্শনী ফ্লো</h2>
          <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3" data-id="element-2288" data-mp="fzrbus7c337g">
            {demoFlows.map((f, i) => <Link key={f.title} to={f.start} className="rounded-lg border border-border bg-white p-4 hover:border-[#1769AA]" data-id="element-2289" data-mp="13plmr483ehp2" data-mpi={i}>
                <div className="flex items-center gap-2" data-id="element-2290" data-mp="18i4zy02vbatc">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#003B71] text-xs font-bold text-white" data-id="element-2291" data-mp="1huvpcnna37k6">{toBn(i + 1)}</span>
                  <span className="font-semibold text-[#003B71]" data-id="element-2292" data-mp="1dtk1amk1yue3">{f.title}</span>
                </div>
                <p className="mt-2 text-[13px] leading-relaxed text-slate-600" data-id="element-2293" data-mp="1rnb8vpe84476">{f.steps.join(' → ')}</p>
              </Link>)}
          </div>
        </section>

        <footer className="mt-12 border-t border-border pt-5 text-center text-xs text-slate-500" data-id="element-2294" data-mp="yxb0vhofeb03">
          এই প্রোটোটাইপ প্রকৃত ডিএমপি প্রসিকিউশন ডাটাবেসের সাথে সংযুক্ত নয়। প্রদর্শিত সকল পরিসংখ্যান ও রেকর্ড উপস্থাপনার উদ্দেশ্যে তৈরি নমুনা তথ্য।
        </footer>
      </main>
    </div>;
}